import { Popover } from '@chakra-ui/react';
import { FilterPopoverButton, FilterPopoverContent } from './FilterPopover';
import { CheckboxFilter } from './CheckboxFilter';
import { ICourse } from '@/shared/ICourse';
import { naturalComparer } from '@/shared/parse';
import React from 'react';

export const CheckboxFilterExpert = (props: {
  allCourses: ICourse[];
  value: string[] | undefined;
  onSetFilter: (value: string[] | undefined) => void;
}) => {

  const getExpertTitle = (expert: { name: string; email: string }) => `${expert.name} (${expert.email})`;

  const options = React.useMemo(() => {
    // Collect all existing experts from courses
    const expertCounts = new Map<string, { expert: { id: string; name: string; email: string }, count: number }>();
    
    props.allCourses?.forEach(course => {
      if (course.expert && course.expertId) {
        const existing = expertCounts.get(course.expertId);
        if (existing) {
          existing.count++;
        } else {
          expertCounts.set(course.expertId, {
            expert: { id: course.expertId, name: course.expert.name, email: course.expert.email },
            count: 1
          });
        }
      }
    });

    return Array.from(expertCounts.values())
      .map(({ expert, count }) => ({
        label: getExpertTitle(expert),
        value: expert.id,
        count
      }))
      .sort((a, b) => naturalComparer.compare(a.label, b.label));
  }, [props.allCourses]);

  const hasSelection = props.value !== undefined && props.value.length > 0;

  return (
    <Popover isLazy placement="bottom-start">
      <FilterPopoverButton label="Reviewer" selected={hasSelection} />
      <FilterPopoverContent>
        <CheckboxFilter
          hideLabel
          showSearch
          value={props.value}
          onChange={(v) => props.onSetFilter(v)}
          options={options} />
      </FilterPopoverContent>
    </Popover>
  );
};
